// Numeric discriminator from the access service.
export enum PrincipalType {
  Tenant = 0,
  Client = 1,
  Machine = 2,
}

export type Account = {
  id: string;
  username: string;
  email: string;
  firstName: string | null;
  lastName: string | null;
  phoneNumber: string | null;
  enabled: boolean;
  realmRoles: string[];
  tenantId: string | null;
  principalType: PrincipalType;
  clientId: string | null;
};
